module.exports = __webpack_public_path__ + "img/TEMPO-967x683.a721118f.png";